import { createInjectionKey } from "../../_utils/vue/create-injection-key.mjs";
export const drawerBodyInjectionKey = createInjectionKey('n-drawer-body');
export const drawerInjectionKey = createInjectionKey('n-drawer');